window.EasyVue ||= {};
window.EasyVue.toggleEntityCardAttributes = async (toggle, config) => {
  const { toggleEntityCardAttributes } = await import("../src/entity_card_toggle/toggleEntityCardAttributes");
  toggleEntityCardAttributes(toggle, config);
};
